export default class App {
    #_packageName: String;
    #_pSetup: String;
    #_verBBE: String;
    #_registrationHost: String;

    constructor(params = {}) {
        this.#_packageName = params.packageName;
        this.#_pSetup = params.pSetup;
        this.#_verBBE = params.verBBE;
        this.#_registrationHost = params.registrationHost;
    }

    getPackageName() {
        return this.#_packageName;
    }

    getPSetup() {
        return this.#_pSetup;
    }

    getVerBBE() {
        return this.#_verBBE;
    }

    getHost() {
        return this.#_registrationHost;
    }

    validate() {
        if (!this.#_pSetup) {
            throw new Error("pSetup must be valid");
        }
        if (!this.#_packageName) {
            throw new Error("packageName must be valid");
        }
    }
}
